// Este archivo proporciona un polyfill para process.env en el navegador

// Define el objeto process global si no existe
if (typeof window !== 'undefined') {
  (window as any).process = {
    env: {
      NODE_ENV: import.meta.env.MODE || 'development',
      // Configuración segura de variables accesibles desde el cliente
      // No incluir claves sensibles como las de API (OPENAI_API_KEY)
      OPENAI_API_KEY: undefined, // La clave real solo está disponible en el servidor
      REPL_ID: import.meta.env.VITE_REPL_ID,
      REPL_OWNER: import.meta.env.VITE_REPL_OWNER,
      REPLIT_DB_URL: import.meta.env.VITE_REPLIT_DB_URL,
    },
  };
  
  console.log('Process polyfill cargado para el navegador');
}

export {};